import * as actionTypes from '../action/actionTypes';

const INITIAL_STATE = {
	entity: {},
	entityList: [],
	resetPasswordStatus: '',
	pending: false,
	messageList: [],
	error: {},
};

export default function resetPasswordReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case actionTypes.RESET_PASSWORD_PENDING:
			return {
				...state,
				pending: true,
				messageList: [],
			};
		case actionTypes.RESET_PASSWORD_SUCCESS:
			return {
				...state,
				pending: false,
				entity: action.payload.entity,
				resetPasswordStatus: action.payload.status,
				messageList: action.payload.messageList,
			};
		case actionTypes.RESET_PASSWORD_FAILED:
			return {
				...state,
				pending: false,
				resetPasswordStatus: 401,
				error: action.error,
			};
		case actionTypes.UPDATE_STATUS: {
			return {
				...state,
				entity: {},
				entityList: [],
				resetPasswordStatus: '',
				pending: false,
				messageList: [],
				error: {},
			};
		}
		default:
			return state;
	}
}
